import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import SeasonType from '@app/types/base/SeasonType';
import { ISeasonPrices } from '@app/types/data/base/IPriceItem';
import ISeason from '@app/types/data/base/ISeason';
import IOfferDSlideData from '@app/types/data/slides/IOfferDSlideData';
import IOfferDPriceMatrixItem from '@app/types/data/slides/present/IOfferDPriceMatrixItem';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import { Entry } from 'contentful';

/**
 * Transform for 012-OfferDSlide
 */
export default class OfferDSlideSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'OfferDSlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferDSlideData> {
		const data: IOfferDSlideData = {
			...(await super.transform(slide, presentationSettings)),
			seasons: (slide.fields.seasons || []).map(
				(seasonEntry: Entry<any>): ISeason => ({
					type: seasonEntry.fields.type as SeasonType,
					title: seasonEntry.fields.title as ISeason['title'],
					startDate: seasonEntry.fields.startDate as ISeason['startDate'],
					endDate: seasonEntry.fields.endDate as ISeason['endDate']
				})
			),
			priceMatrix: slide.fields.list.map((item: Entry<any>): IOfferDPriceMatrixItem => {
				// season prices for each price category may or may not be provided.
				// Use season prices if provided, default to default season price otherwise.

				const getPrice = (fieldName: string): number | ISeasonPrices => {
					let price: number | ISeasonPrices = (item.fields[fieldName] as number) ?? 0;

					// if high and/or low season prices are provided, use them instead of default season price
					if (item.fields[`${fieldName}HighSeason`] || item.fields[`${fieldName}LowSeason`]) {
						price = {
							highSeason: (item.fields[`${fieldName}HighSeason`] as ISeasonPrices['highSeason']) || undefined,
							lowSeason: (item.fields[`${fieldName}LowSeason`] as ISeasonPrices['lowSeason']) || undefined,
							defaultSeason: (item.fields[fieldName] as ISeasonPrices['defaultSeason']) || 0
						};
					}

					return price;
				};

				return {
					activityCount: item.fields.numberOfActivities as IOfferDPriceMatrixItem['activityCount'],
					individuals: {
						adult: getPrice('individualsAdult'),
						adultDiscounted: getPrice('individualsAdultDiscounted'),
						child: getPrice('individualsChild'),
						childDiscounted: getPrice('individualsChildDiscounted')
					},
					groups: {
						adult: getPrice('groupsAdult'),
						adultDiscounted: getPrice('groupsAdultDiscounted'),
						child: getPrice('groupsChild'),
						childDiscounted: getPrice('groupsChildDiscounted')
					}
				};
			})
		};

		return data;
	}
}
